import React from 'react';

const OPTIONS = [
  { value: 'inherit', label: 'Inherit (use parent rule)', compactLabel: 'Inherit' },
  { value: 'returnable', label: 'Returnable', compactLabel: 'Returnable' },
  { value: 'non_returnable', label: 'Non-returnable', compactLabel: 'No returns' },
];

export default function ReturnAllowanceSelect({
  id,
  label,
  value,
  onChange,
  hint,
  className = '',
  compact = false,
}) {
  const v = OPTIONS.some((o) => o.value === value) ? value : 'inherit';

  return (
    <div
      className={`admin-return-allowance${compact ? ' admin-return-allowance--compact' : ''}${
        className ? ` ${className}` : ''
      }`}
    >
      <label className={`form-label${compact ? ' visually-hidden' : ' small mb-1'}`} htmlFor={id}>
        {label}
      </label>
      <select
        id={id}
        className="form-select form-select-sm admin-return-allowance__select"
        value={v}
        onChange={(e) => onChange(e.target.value)}
        title={OPTIONS.find((o) => o.value === v)?.label}
      >
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {compact ? o.compactLabel || o.label : o.label}
          </option>
        ))}
      </select>
      {hint ? <p className="small text-muted mb-0 mt-1">{hint}</p> : null}
    </div>
  );
}
